<script>
  let className = '';
  export {className as class};
  export let type = '';
  export let background = '#003398';
  export let style = 'background: #fff; opacity: 0.6;';

  const items = [1, 2, 3, 4];
</script>

<style>
  .wrap {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    justify-content: center;
    z-index: 7999;
  }
  .dark.wrap {
    background: #141414 !important;
    z-index: 799;
  }
  .spin-dot {
    width: 25px;
    height: 25px;
    flex-wrap: wrap;
    justify-content: space-between;
    -webkit-animation: spinAnimation 1s linear infinite;
  }
  .circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #003398;
  }
  .circle:nth-child(2) {
    opacity: 0.8;
  }
  .circle:nth-child(3) {
    opacity: 0.6;
  }
  .circle:nth-child(4) {
    opacity: 0.4;
  }
  @keyframes spinAnimation {
    0% {
      -webkit-transform: rotate(0deg);
    }
    25% {
      -webkit-transform: rotate(90deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    75% {
      -webkit-transform: rotate(270deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
</style>

<div class="wrap pa df aic jcsb br12 {className}" {style} class:dark={type === 'dark'}>
  <div class="spin-dot df aic">
    {#each items as item}
      <i class="circle" style="background:{background}" />
    {/each}
  </div>
</div>
